import { PRODUCT_AREA_COLORS } from '../../../utils/color.js';

var script = {
  name: 'PendoGroupCell',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    name() {
      return this.row.group.name || 'No Product Area';
    },
    color() {
      if (this.row.group && this.row.group.color) {
        let {
          color
        } = this.row.group;
        if (color.includes('.')) {
          color = color.substr(1);
        }
        return PRODUCT_AREA_COLORS[color];
      }
      return PRODUCT_AREA_COLORS.groupColorUngrouped;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-group-cell.vue2.js.map
